import { render } from "./profile-image.vue?vue&type=template&id=4f32489e&scoped=true"
import script from "./profile-image.vue?vue&type=script&lang=js"
export * from "./profile-image.vue?vue&type=script&lang=js"

import "./profile-image.vue?vue&type=style&index=0&id=4f32489e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f32489e"]])

export default __exports__